import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MainNavbar from './Components/MainNavbar';
import MainFooter from './Components/MainFooter';
import Hero from './Sections/Hero';
// import ProblemSolution from './Sections/ProblemSolution';
import Features from './Sections/Features';
import ProductDemo from './Sections/ProductDemo';
// import SocialProof from './Sections/SocialProof';
// import PricingFaq from './Sections/PricingFaq';
// import AboutCta from './Sections/AboutCta';
import { useLandingAnimations } from './animations';
import './index.css';

function Landing(rest) {
	const dispatch = useDispatch();
	useLandingAnimations();

	useEffect(() => {
		document.title = 'Weciny | Business Growth';
		const description =
			'Build a free online store, connect with local customers, and let AI handle marketing, bookings, and customer communication.';
		let meta = document.querySelector('meta[name="description"]');
		if (!meta) {
			meta = document.createElement('meta');
			meta.setAttribute('name', 'description');
			document.head.appendChild(meta);
		}
		meta.setAttribute('content', description);
	}, []);

	useEffect(() => {
		try {
			dispatch(rest.removeError());
			dispatch(rest.removeSuccess());
		} catch (err) {
			console.log(err);
		}
	}, [dispatch, rest.removeError, rest.removeSuccess]);

	return (
		<div className='landing-page'>
			<MainNavbar />
			<main>
				<Hero />
				{/* <ProblemSolution /> */}
				<Features />
				<ProductDemo />
				{/* <SocialProof /> */}
				{/* <PricingFaq /> */}
				{/* <AboutCta /> */}
			</main>
			<MainFooter />
		</div>
	);
}

export default Landing;
